import React from 'react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { DisciplineOptions, getAgencySettingsOptions, editDisciplineAgencySettingsOptions } from '@generated';
import Yup from '~/util/yup';
import { CheckboxGroupFormField } from '~/shared/forms/controls/fields/CheckboxGroupFormField';
import { Stethoscope } from 'lucide-react';
import type { SettingsSectionItem } from '~/libraries/settings/SettingsSection';
import { LibraryForm } from '../shared/LibraryForm';

export const DisciplineAgencySettingsSection = {
	settingsView: 'discipline',
	title: 'Discipline Settings',
	description: 'Set up disciplines and specialties for your agency',
	TitleIcon: Stethoscope
} satisfies SettingsSectionItem;

const validationSchema = Yup.object().shape({
	requiredDisciplines: Yup.array().of(Yup.string()).label('Disciplines Required For Each Case'),
	disabledDisciplines: Yup.array().of(Yup.string()).label('Disabled Disciplines')
});

export function DisciplineAgencySettingsForm() {
	const { data: settings } = useSuspenseQuery(getAgencySettingsOptions());
	return (
		<LibraryForm
			initialValues={{
				requiredDisciplines: settings?.requiredDisciplines || [],
				disabledDisciplines: settings?.disabledDisciplines || []
			}}
			saveMutation={{
				...editDisciplineAgencySettingsOptions,
				invalidateQueryKeys: [getAgencySettingsOptions().queryKey]
			}}
			validationSchema={validationSchema}
			{...DisciplineAgencySettingsSection}
		>
			<CheckboxGroupFormField
				name="requiredDisciplines"
				options={DisciplineOptions}
				optionStyle={{
					optionClassName: 'gap-2 rounded-lg border border-gray-200 p-3 transition-colors hover:bg-gray-50',
					optionSelectedClassName: 'bg-gray-50'
				}}
			/>

			<CheckboxGroupFormField
				name="disabledDisciplines"
				options={DisciplineOptions}
				optionStyle={{
					optionClassName: 'gap-2 rounded-lg border border-gray-200 p-3 transition-colors hover:bg-gray-50',
					optionSelectedClassName: 'bg-gray-50'
				}}
			/>
		</LibraryForm>
	);
}
